<template>
  <div
    :style="{ background: route.path === '/' ? '#052784' : '' }"
    class="h5-home"
  >
    <KeywordsMiniHeader :hidden="!showMiniHeader" />
    <div
      class="h5-home-header"
      :class="{ hidden: showMiniHeader }"
    >
      <Header />
      <Partner />
      <ShopCategory />
    </div>
    <HomeProduct />
    <VerifyFactoryBanner />
  </div>
</template>

<script setup>
import Header from './components/Header/index.vue'
import HomeProduct from './components/HomeProduct/index.vue'
import Partner from './components/Partner/index.vue'
import ShopCategory from './components/ShopCategory/index.vue'
import { KeywordsMiniHeader } from '@/components/H5/NavHeader'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import VerifyFactoryBanner from './components/VerifyFactoryBanner/index.vue'
import { useRoute } from 'vue-router'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useUserStore } from '@/pinia/user'

const route = useRoute()

const store = useStore()

const user = useUserStore()

onMounted(() => {
  gaAnalytics('mp_home_page_view', 'mp_home_page_view', { bdUserId: user.userInfo.uid })
  window.addEventListener('scroll', handleHomeScroll)
  buriedEmail()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleHomeScroll)
})

const buriedEmail = () => {
  const { emailType = '', email_id: emailId = '' } = route.query
  if (!!emailType && window.location.pathname === '/') {
    buriedPointUtil({ eventId: 'MPHM501', emailId: atob(emailId) })
  }
}

const showMiniHeader = ref(false)
let lastScrollTop = 0
const handleHomeScroll = (e) => {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
  const clientHeight = document.documentElement.clientHeight || document.body.clientHeight

  if (scrollTop > 314 && scrollTop > lastScrollTop) {
    // 向下滚动，显示小头部
    showMiniHeader.value = true
  } else if (scrollTop < lastScrollTop) {
    // 向上滚动，显示大头部
    showMiniHeader.value = false
  }
  lastScrollTop = scrollTop

  if (scrollTop + 75 > scrollHeight - clientHeight) {
    if (route.path === '/') {
      const { data: adsWord } = route.query
      if (adsWord) return
      store.dispatch('loadMoreHomeData')
    }
  }
}

const preSearch = computed(() => store.state.search.preSearch)
watch(preSearch, (value) => {
  if (value) {
    const { data: adsWord } = route.query
    if (adsWord) return
    store.dispatch('loadMoreHomeData')
  }
})
</script>

<style lang="less" scoped>
.h5-home {
  &-header  {
    transition: transform .3s ease;
    background-color: #052784;
    &.hidden {
      transform: translateY(-100%);
    }
  }
}
</style>
